module.exports = __webpack_public_path__ + "img/ic_bed_heat5.d6326e26.png";